
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M1.06 7.329v14.02c0 1.658 1.422 3.003 3.175 3.003h9.53c1.754 0 3.176-1.345 3.176-3.004V7.328H1.06zm4.238 13.866c0 .365-.238.66-.531.66h-.532c-.293 0-.531-.295-.531-.66V9.985c0-.352.223-.633.501-.653h.591c.278.02.501.3.501.652v11.211h.001zm4.764 0c0 .365-.237.66-.53.66H8.468c-.293 0-.53-.295-.53-.66V9.985c0-.352.222-.633.5-.653h1.123c.278.02.5.3.5.652v11.211h.002zm4.234-11.21v11.21c0 .365-.237.66-.531.66h-.532c-.293 0-.53-.295-.53-.66V9.985c0-.352.222-.633.5-.653h.591c.28.02.502.3.502.652zm2.645-6.661H1.06c-.585 0-1.059.448-1.059 1v.501c0 .554.474 1.002 1.06 1.002H16.94c.585 0 1.059-.448 1.059-1.002v-.5c0-.553-.474-1.001-1.059-1.001zM7.751.82h2.687c.585 0 1.058.449 1.058 1.002v.5c0 .554-.474 1.002-1.058 1.002H7.75c-.585 0-1.059-.448-1.059-1.002v-.5c0-.553.474-1.002 1.06-1.002z","fill":"#fff"}})])
          )
        }
      }
    